import {
  Activity,
  Building2,
  CalendarClock,
  ChartColumnBig,
  CloudCog,
  GitBranch,
  LayoutList,
  ShieldCheck,
  TrendingDown,
  UsersRound,
} from 'lucide-react'
import { Link, useLocation } from 'react-router'
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/sv/sidebar'

const menuItems = [
  {
    title: 'Companies',
    url: '/superadmin',
    activeMatch: (pathname: string) =>
      pathname === '/superadmin' ||
      pathname.startsWith('/superadmin/companies'),
    icon: Building2,
  },
  {
    title: 'Users',
    url: '/superadmin/user-details',
    icon: UsersRound,
  },
  {
    title: 'Services',
    url: '/superadmin/search',
    icon: LayoutList,
  },
  {
    title: 'Blocked Git',
    url: '/superadmin/blocked-git',
    icon: GitBranch,
  },
  {
    title: 'Health monitor',
    url: '/superadmin/customer-health-monitor',
    icon: Activity,
  },
  {
    title: 'Churns',
    url: '/superadmin/churns',
    icon: TrendingDown,
  },
  {
    title: 'Stats',
    url: '/superadmin/stats',
    icon: ChartColumnBig,
  },
  {
    title: 'OCI migration',
    url: '/superadmin/oci-migration',
    activeMatch: (pathname: string) =>
      pathname === '/superadmin/oci-migration' ||
      pathname.startsWith('/superadmin/oci-migration/'),
    icon: CloudCog,
  },
  {
    title: 'OCI migration schedule',
    url: '/superadmin/oci-migration-schedule',
    icon: CalendarClock,
  },
  {
    title: 'OCI migration precheck',
    url: '/superadmin/oci-migration-precheck',
    icon: ShieldCheck,
  },
] as const

export const SuperNav = () => {
  const location = useLocation()

  return (
    <SidebarGroup>
      <SidebarGroupContent>
        <SidebarMenu>
          {menuItems.map((item) => {
            const isActive =
              'activeMatch' in item && typeof item.activeMatch === 'function'
                ? item.activeMatch(location.pathname)
                : 'exactMatch' in item && item.exactMatch
                  ? location.pathname === item.url
                  : location.pathname.startsWith(item.url)
            return (
              <SidebarMenuItem key={item.title}>
                <SidebarMenuButton asChild isActive={isActive}>
                  <Link to={item.url}>
                    <item.icon />
                    <span>{item.title}</span>
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
            )
          })}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  )
}
